import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getADUserState } from '../reducers/auth.reducers';
/**
 * Feature selector for the auth state
 */
export const getAuthState = createFeatureSelector('auth');
/**
 * Selector to get the AD user from the state
 */
export const getADUser = createSelector(getAuthState, getADUserState);
/**
 * Selector to get the AD user id from the state
 */
export const getUserId = createSelector(getADUser, user => user && user.profile.oid);
//# sourceMappingURL=auth.selectors.js.map